@use '@ingka/variables/style.scss' as *;

.maintenanceContainer {
  > *:not(:last-child) {
    margin-block-end: $space-150;
  }

  img {
    aspect-ratio: 8/6;
    width: 100%;
    object-fit: cover;
  }
}
